import { render, staticRenderFns } from "./TermsAMAZSD69ECS2022.vue?vue&type=template&id=7caa67b4"
import script from "./TermsAMAZSD69ECS2022.vue?vue&type=script&lang=js"
export * from "./TermsAMAZSD69ECS2022.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports